import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/generate-global-sucursales", "documento": "invoices", "acceso": "sesion", "filas": ["021"], "cita": "prod:Areas/Invoices/Controllers/GenerateController.cs:147"} satisfies RutaProd;
